export function regularChannelHasCredits(channelId: number, data: any) {
  const channel = data[channelId]
  if(channel == undefined) return false
  return channel.used < channel.total
}
